import React, { useContext } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import FormContext from "./FormContext";

import ChevronDown from "../assets/chevron-down.svg";

const FormControl = ({
  id,
  className,
  icon,
  as: Component,
  isInvalid,
  ...props
}) => {
  const { controlId } = useContext(FormContext);
  const classes = classNames("form-control", className, {
    "form-control--invalid": isInvalid
  });

  const renderComponent = (
    <Component {...props} id={id || controlId} className={classes} />
  );

  if (Component === "select" || icon) {
    return (
      <div className="form-control-wrapper">
        {renderComponent}
        {Component === "select" && <img src={ChevronDown} alt="Select" />}
        {icon && icon}
      </div>
    );
  }

  return renderComponent;
};

FormControl.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  as: PropTypes.oneOf(["input", "select", "textarea"]),
  icon: PropTypes.node
};

FormControl.defaultProps = {
  as: "input"
};

export default FormControl;
